import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ResumeEmptyCardId extends BaseOption {
  // Compile is the identity: a cached value unlike the raw one is stale (DynamicOption ignores it).
  static compiledIsRaw = true;

  static userInterfaceComponent = {
    label: "Empty State Card",
    component: inspectorTools.NONE,
    props: {},
  };

  static defaultValue = 0;
}
